// extracted by mini-css-extract-plugin
export default {"container":"aL-z","topReviewHeading":"bL-z","criticalReview":"cL-z","favorableReview":"dL-z","vsSeparator":"eL-z"};